import{__exports as e}from"../../../../_virtual/utils4.js";Object.defineProperty(e,"__esModule",{value:!0}),e.getLowerCase=void 0,e.getLowerCase=function(e){return e?e.toLowerCase():e};export{e as default};
